// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { injectable } from 'inversify';
// import { observable, computed, action } from 'mobx';

import BaseStore from '@core/stores/base';
import container from '@core/di';
import HotspotsService from '@shared/services/hotspots';
import HotspotItem, { HotspotItemDTO } from '@shared/models/dashboard/hotspot-item';
// import { ListRequestParams, PageInfo } from '@shared/types/services';

@injectable()
export default class HotspotsStore extends BaseStore<HotspotItemDTO, HotspotItem, HotspotsService> {
  static diToken = Symbol('hotspots-store');
  /* Use baseclase???  Service must use the correct name for the virtual methods.
  @observable private _notificationItems: Array<Hotspot> = [];
  @observable private _notificationItemsPageInfo: PageInfo;
  */
  constructor() {
    super({ service: container.get<HotspotsService>(HotspotsService.diToken) });
  }
}